<template>
  <slot name="stepper-main">
    <progress-bar
      :action="action"
      :key="currentStep"
      :options="getOptions()"
      :resource="resource"
      :stepper="stepper"
      :update-action="updateAction"
    ></progress-bar>
    <component
      :data="data"
      :is="getComponent()"
      :key="currentStep"
      :options="getOptions()"
      :resource="resource"
      @add:toasts="(toasts) => handleFeedback(toasts)"
      @prevent:progression="(denied) => denyProgression(denied)"
      @trigger:next="(allowed) => triggerNext(allowed, route(`${routePrefix}.${resourceType}.${updateAction}`, resource.data.id))"
    ></component>
  </slot>
  <slot name="stepper-side">
    <navigation
      :action="action"
      :key="currentStep"
      :next="next()"
      :prevent-progression="progressionDenied || preventProgression() || errorFeedback"
      :previous="previous()"
      :resource="resource"
      :stepper="stepper"
      :update-action="updateAction"
    ></navigation>
  </slot>
</template>

<script>
import { defineAsyncComponent, ref } from 'vue';
import useStepper from '@kanrisha/composables/useStepper';
import ProgressBar from '@kanrisha/components/Stepper/ProgressBar';
import Navigation from '@kanrisha/components/Stepper/Navigation';

export default {
  components: { Navigation, ProgressBar },
  props: {
    action: { type: String, default: () => 'edit' },
    data: { type: Object, default: () => {} },
    preventProgression: { type: Function, default: () => {} },
    resource: { type: Object, default: () => {} },
    stepper: { type: Object, default: () => {} },
    stepsLocation: { type: String, default: () => 'structures/default/components/steps' },
    updateAction: { type: String, default: () => 'update' },
  },
  emits: ['add:toasts'],
  setup(props, { emit }) {
    const resourceType = ref(props.resource.meta.resourceType);
    const { currentStep, denyProgression, getOptions, next, previous, progressionDenied, triggerNext } =
      useStepper(props);
    const errorFeedback = ref(false);

    const getComponent = () => {
      try {
        let step = currentStep.value.charAt(0).toUpperCase() + currentStep.value.slice(1);
        require(`@/${props.stepsLocation}/${step}`);

        return defineAsyncComponent(() => import(`@/${props.stepsLocation}/${step}`));
      } catch (e) {
        //
      }
    };

    const handleFeedback = (toasts) => {
      emit('add:toasts', toasts);
      errorFeedback.value = !!toasts.length;
    };

    return {
      currentStep,
      denyProgression,
      errorFeedback,
      getComponent,
      getOptions,
      handleFeedback,
      next,
      previous,
      progressionDenied,
      resourceType,
      triggerNext,
    };
  },
};
</script>
